import {Component, ElementRef, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {ErrorModalComponent} from '../../errorhandler/error-modal/error-modal.component';
import {UserData} from '../../authentication/user.model';
import {OfficeAllocation} from '../model/office-allocation.model';
import {LeadSource} from '../model/lead-source.model';
import {AgentService} from '../service/agent.service';
import {LeadService} from '../service/lead.service';
import {AuthenticationService} from '../../authentication/authentication.service';
import {LeadSourceService} from '../service/lead-source.service';
import {TenantService} from '../../authentication/tenant.service';

@Component({
  selector: 'app-transition',
  templateUrl: './transition.component.html',
  styleUrls: ['./transition.component.scss']
})
export class TransitionComponent {

  user: UserData;

  providerAgent: OfficeAllocation;

  providerAgentOptions: OfficeAllocation[];

  leadSource: LeadSource;

  formData: FormData;
  formState: TransitionState = TransitionState.NEW;
  files: File[] = [];

  formIsValid: boolean = false;

  preferredAgent: OfficeAllocation;

  constructor(private route: ActivatedRoute,
              private agentService: AgentService,
              private leadService: LeadService,
              private matDialog: MatDialog,
              private toastrService: ToastrService,
              private authenticationService: AuthenticationService,
              private leadSourceService: LeadSourceService,
              private tenantService: TenantService) {
    if (!window.location.host.startsWith('localhost')) {
      window.location.href = window.location.protocol + '//' + window.location.host + '/tng';
    }

    leadSourceService.getCurrentLeadSource().subscribe(
      leadSource => this.leadSource = leadSource,
      error => matDialog.open(ErrorModalComponent, {data: error})
    );
    authenticationService.authenticatedUser.subscribe(user => {
      this.user = user;
      tenantService.getCurrentTenantInfo().subscribe(tenantInfo => {
        if (tenantInfo.id) {
          agentService.getAgentsOfCurrentUser().subscribe(
            agentPage => {
              if (agentPage?._embedded?.officeAllocations) {
                if (agentPage._embedded.officeAllocations.length > 1) {
                  this.providerAgentOptions = agentPage._embedded.officeAllocations;
                }
                this.providerAgent = agentPage._embedded.officeAllocations[0];
              }
            },
          );
        }
      });
    });
  }

  initFormData() {
    this.formData.set('referer', window.location.href);
    this.formData.set('providerAgentId', this.providerAgent.id);
    this.formData.set('providerAgentType', this.providerAgent._embedded.activity.name);
    this.formData.set('preferredAgentId', this.preferredAgent.id);
    this.files.forEach((file, index) => {
      this.formData.append('file' + index, file);
    });
  }

  onSubmit(formEvent) {
    this.formData = new FormData(formEvent.target);
    this.initFormData();

    if (!this.formIsValid && this.providerAgent) {
      this.formState = TransitionState.SUBMIT_FAILED;
      this.toastrService.warning('Bitte prüfen Sie ihre Eingaben');
    } else {
      this.createLead();
    }
  }

  createLead() {
    this.formState = TransitionState.SENDING;
    this.leadService.postLead(this.leadSource.id, this.formData)
      .subscribe(response => this.formState = TransitionState.SUCCESS,
        error => {
          this.formState = TransitionState.SUBMIT_FAILED;
          this.matDialog.open(TransitionErrorModalComponent, {data: error});
        });
  }

  resetForm() {
    this.formState = TransitionState.NEW;
    this.formData = new FormData();
    this.files = [];
  }

  getEmailLinkWithData() {
    const listOfFiles = this.getListOfFileNames();
    return 'mailto:?' +
      'subject=' + encodeURIComponent(
        'Überleitung von '
        + this.formData.get('mainApplicant_salutation') + ' '
        + this.formData.get('mainApplicant_firstName') + ' '
        + this.formData.get('mainApplicant_lastName') + ' an '
        + this.getDativ(this.preferredAgent?._embedded?.employee?._embedded?.salutation?.name) + ' '
        + this.preferredAgent._embedded.employee.firstName + ' '
        + this.preferredAgent._embedded.employee.lastName) +
      '&body=' + encodeURIComponent(
        'Überleitung wurde gesendet an '
        + this.getDativ(this.preferredAgent?._embedded?.employee?._embedded?.salutation?.name) + ' '
        + this.preferredAgent._embedded.employee.firstName + ' '
        + this.preferredAgent._embedded.employee.lastName + '\n\n'
        + 'Daten des Interessenten: \n'
        + '------------------------------------------------------\n'
        + 'Anrede: ' + this.formData.get('mainApplicant_salutation') + '\n'
        + 'Vorname: ' + this.formData.get('mainApplicant_firstName') + '\n'
        + 'Nachname: ' + this.formData.get('mainApplicant_lastName') + '\n'
        + 'Geburtstag: ' + this.formData.get('mainApplicant_birthday') + '\n'
        + 'PLZ: ' + this.formData.get('mainApplicant_zipCode') + '\n'
        + 'Ort: ' + this.formData.get('mainApplicant_city') + '\n'
        + 'E-Mail: ' + this.formData.get('mainApplicant_email') + '\n'
        + 'Telefon: ' + this.formData.get('mainApplicant_privatePhone') + '\n'
        + 'Präferierter Kontaktweg: ' + this.formData.get('mainApplicant_reachabilityComment') + '\n'
        + '------------------------------------------------------\n\n'
        + 'Angaben zur Immobilie: \n'
        + '------------------------------------------------------\n'
        + 'Straße: ' + this.formData.get('object_street') + '\n'
        + 'Hausnummer: ' + this.formData.get('object_streetNumber') + '\n'
        + 'PLZ: ' + this.formData.get('object_zipCode') + '\n'
        + 'Ort: ' + this.formData.get('object_city') + '\n'
        + 'Grundstücksgröße in m²: ' + this.formData.get('object_landSize') + '\n'
        + 'Wohnfläche gesamt: ' + this.formData.get('object_completeLivingSpace') + '\n'
        + 'Baujahr: ' + this.formData.get('object_constructionYear') + '\n'
        + 'Art der Immobilie: ' + this.formData.get('object_type') + '\n'
        + '------------------------------------------------------\n\n'
        + (this.formData.get('remarks') ? 'Ihre Nachricht: \n'
        + '------------------------------------------------------\n'
        + this.formData.get('remarks') + '\n'
        + '------------------------------------------------------\n\n' : '')
        + (listOfFiles && listOfFiles.length > 0 ? 'Angehängte Dokumente: \n'
        + '------------------------------------------------------\n'
        + listOfFiles.join('\n') + '\n'
        + '------------------------------------------------------\n\n' : '')
        + 'Kunden-Zustimmung: Hiermit bestätige ich, dass die übermittelten Kontaktdaten vollständig und korrekt sind und der Kunde in die Übermittlung ' +
        'seiner Daten an die Dr. Klein Privatkunden AG, Hansestr. 14, 23558 Lübeck, sowie an deren angebundene Franchise- und Vermittlungspartner, ' +
        'zur weiteren Beratung per E-Mail oder Telefon eingewilligt hat.');
  }

  private getListOfFileNames(): string[] {
    const filenames: string[] = [];
    this.formData.forEach((value, key) => {
      if (value instanceof File) {
        filenames.push(value.name);
      }
    });
    return filenames;
  }

  getDativ(salutation: string) {
    if (salutation) {
      return salutation === 'Herr' ? 'Herrn' : salutation;
    }
    return '';
  }
}

@Component({
  selector: 'app-question-modal',
  templateUrl: './bcc-confirmation-modal.html'
})
export class BccConfirmationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BccConfirmationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string) {
  }

  ngOnInit(): void {
  }

}

export enum TransitionState {
  NEW = 'NEW',
  SENDING = 'SENDING', // form is currently being sent
  SUBMIT_FAILED = 'SUBMIT_FAILED', // user tried to submit but form fields were invalid or server responded with error
  SUCCESS = 'SUCCESS' // form was successfully submitted
}

@Component({
  selector: 'app-transition-error-modal',
  templateUrl: './transition-error-modal.html'
})
export class TransitionErrorModalComponent implements OnInit {

  @ViewChild('errorMessage')
  private errorMessageContainer: ElementRef;

  constructor(public dialogRef: MatDialogRef<TransitionErrorModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
  }

  getErrorMailUrl() {
    return 'mailto:plattform-support@drklein.de﻿?subject=Fehler in Überleitungstool 2.0&body=' + encodeURIComponent(
      'Es ist ein Fehler in dem Überleitungstool 2.0 aufgetreten: \n\n'
      + 'Link zum Tool: ' + window.location.href + '\n\n'
      + 'Fehlerbericht: \n----------------------------------------------------------\n'
      + JSON.stringify(this.data) + '\n\n');
  }
}

